import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const defaultFeatures = {
  dirham: process.env.REACT_APP_FEATURE_DIRHAM !== 'false',
};

const FeatureContext = createContext({
  features: defaultFeatures,
  isFeatureEnabled: (name) => !!defaultFeatures[name],
  loading: false,
});

export const useFeatures = () => useContext(FeatureContext);

export const FeatureProvider = ({ children }) => {
  const [features, setFeatures] = useState(defaultFeatures);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    axios
      .get('/api/features')
      .then((res) => {
        if (isMounted && res.data && typeof res.data === 'object') {
          setFeatures((prev) => ({
            ...prev,
            ...res.data,
          }));
        }
      })
      .catch(() => {
        // Fallback to /api/auth/config if /api/features fails
        return axios.get('/api/auth/config').then((res) => {
          if (isMounted && res.data?.features) {
            setFeatures((prev) => ({
              ...prev,
              ...res.data.features,
            }));
          }
        });
      })
      .catch(() => {
        // Keep default features if offline or network fails
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  const isFeatureEnabled = (name) => {
    if (!name) return false;
    const normalized = String(name).toLowerCase().trim();
    if (normalized === 'dirham' || normalized === 'our_dirham' || normalized === 'dirham_dialna') {
      return !!features.dirham;
    }
    return !!features[name];
  };

  return (
    <FeatureContext.Provider value={{ features, isFeatureEnabled, loading }}>
      {children}
    </FeatureContext.Provider>
  );
};

export default FeatureContext;
